module.exports = __webpack_public_path__ + "static/development-illustration-d7400a336e7f28c504864dbae5dfcde4.svg";